"use strict";
/**
 * AngularJS popup component controller.
 *
 * @packageDocumentation
 * @module Popup
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#endregion
var base_1 = require("../base");
var IMRPopupController = /** @class */ (function (_super) {
    tslib_1.__extends(IMRPopupController, _super);
    //#region Ctor
    function IMRPopupController() {
        return _super.call(this) || this;
    }
    //#endregion
    //#region Lifecycle
    IMRPopupController.prototype.initialize = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.initialize.call(this, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    //#endregion
    //#region IIMRPopup Implementation
    IMRPopupController.prototype.getInnerPopup = function () {
        return this.overlay;
    };
    IMRPopupController.prototype.show = function () {
        var _a;
        (_a = this.overlay) === null || _a === void 0 ? void 0 : _a.show();
    };
    return IMRPopupController;
}(base_1.OverlayController));
exports.IMRPopupController = IMRPopupController;
//# sourceMappingURL=popup.controller.js.map